import { ReturnPolicySnapshotSettingsSchema } from "@redotech/redo-return-core-common/return-policy/snapshot-settings";
import { returnPolicyIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";

/** Saves the settings as the policy's draft without publishing them. */
export const saveReturnPolicyDraft = {
  name: "saveReturnPolicyDraft" as const,
  input: z.object({
    id: returnPolicyIdFormat.schema,
    settings: ReturnPolicySnapshotSettingsSchema,
  }),
  output: z.object({ updatedAt: z.date() }),
};
